// extracted by css-extract-rspack-plugin
export default {"seo_only":"VDs2I","seoOnly":"VDs2I"};